import { useCallback } from "react";

import AutomationActionBlockApplication from "@components/automations/applicationBlocks/AutomationActionBlockApplication";
import AutomationConditionBlockApplication from "@components/automations/applicationBlocks/AutomationConditionBlockApplication";
import AutomationTimingBlockApplication from "@components/automations/applicationBlocks/AutomationTimingBlockApplication";
import AutomationTriggerBlockApplication from "@components/automations/applicationBlocks/AutomationTriggerBlockApplication";
import { AutomationApplicationFragment as AutomationApplicationType } from "@typing/Generated";
import { sortByPosition } from "@utils/modelUtils";

type AutomationBlockApplicationType = AutomationApplicationType["automationBlockApplications"][number];

type Props = {
  automationApplication: AutomationApplicationType;
};

const AutomationApplication = ({ automationApplication }: Props) => {
  const orderedBlockApplications = sortByPosition(automationApplication.automationBlockApplications);

  const renderBlockApplication = useCallback(
    (blockApplication: AutomationBlockApplicationType) => {
      const block = automationApplication.automation.blocks.find(
        block =>
          block.id === blockApplication.automationBlock.id &&
          block.__typename === blockApplication.automationBlock.__typename
      );

      if (block?.__typename === "AutomationActionBlock") {
        return (
          <AutomationActionBlockApplication
            automationApplication={automationApplication}
            block={block}
            blockApplication={blockApplication}
          />
        );
      }
      if (block?.__typename === "AutomationConditionBlock") {
        return (
          <AutomationConditionBlockApplication
            automationApplication={automationApplication}
            block={block}
            blockApplication={blockApplication}
          />
        );
      }
      if (block?.__typename === "AutomationTimingBlock") {
        return (
          <AutomationTimingBlockApplication
            automationApplication={automationApplication}
            block={block}
            blockApplication={blockApplication}
          />
        );
      }
      if (block?.__typename === "AutomationTriggerBlock") {
        return (
          <AutomationTriggerBlockApplication
            automationApplication={automationApplication}
            block={block}
            blockApplication={blockApplication}
          />
        );
      }

      return <div>{JSON.stringify(block)}</div>;
    },
    [automationApplication]
  );

  return (
    <>
      {orderedBlockApplications.map(blockApplication => (
        <div key={blockApplication.id}>{renderBlockApplication(blockApplication)}</div>
      ))}
    </>
  );
};

export default AutomationApplication;
